// Constants for different requests for current reducer
export default {
  company: 'COMPANY',
  enableVisitorLog: 'ENABLE_VISITOR_LOG',
  disableVisitorLog: 'DISABLE_VISITOR_LOG',
  enableSSO: 'ENABLE_SSO',
  disableSSO: 'DISABLE_SSO',
  updateSSOConfiguration: 'UPDATE_SSO_CONFIGURATION',
  ssoConfiguration: 'SSO_CONFIGURATION',
  enableBranches: 'ENABLE_BRANCHES',
  disableBranches: 'DISABLE_BRANCHES',
  updateMaxShiftHours: 'UPDATE_COMPANY_MAX_SHIFT_HOURS',
  switchGpsRequired: 'COMPANIES_SWITCH_GPS_REQUIRED',
  enableChat: 'ENABLE_CHAT',
  disableChat: 'DISABLE_CHAT',
};
